import React from 'react'
import { Link } from 'react-router-dom'
import get from 'lodash/get'

import { Button, Page } from '@fielded/shared-ui'

import { CloseCircle, MinusCircle, PlusCircle } from '@fielded/shared-ui/src/icons'

import ShipmentHeader from '../common/ShipmentHeader'

const ShipmentOptions = (
  {
    breadcrumbItems,
    closeUrl,
    shipment,
    headerLocation,
    formattedDate,
    addProductsLink,
    deleteShipmentLink,
    deleteProducts,
    config,
    history,
    location
  }) => {
  const redirectLink = get(location, 'state.redirectLink', '')

  const onHandleDeleteAction = (url) => {
    history.push({
      pathname: url,
      state: { redirectLink }
    })
  }

  return (
    <Page className='shipment-options'>
      <ShipmentHeader
        breadcrumbItems={breadcrumbItems}
        location={headerLocation}
        formattedDate={formattedDate}
        shipment={shipment}
        config={config}
        redirectLink={redirectLink}
        hasShipmentDetails
        isOptions
      />
      <Page.Panel withMargin={false} spread>
        <div className='shipment-options__content-wrapper'>
          <div className='shipment-options__content'>

            {/* hide date updating feature tempoarily for rollout. See https://github.com/fielded/van-orga/issues/771 */}
            {/* <div className='shipment-options__option'>
              <p className='shipment-options__option-intro'>You can change the date this shipment is expected to be distributed.</p>
              <Button
                component={Link}
                to={`/shipments/pick-list/${shipment.snapshotId}/shipment-options/change-date`}
                colorVariant='brand'
                fill='outline'
              >
                Change shipment date
              </Button>
            </div>

            <br /> */}

            {deleteProducts && (
              <div className='shipment-options__option'>
                <p className='shipment-options__option-intro'>If there is a whole product type that won’t be distributed, you can remove it.</p>
                <Button
                  colorVariant='brand'
                  fill='outline'
                  icon={<MinusCircle />}
                  onClick={() => {
                    onHandleDeleteAction(`/shipments/pick-list/${shipment.snapshotId}/shipment-options/remove-products`)
                  }}
                >
                  Remove products
                </Button>
              </div>
            )}

            {addProductsLink && (
              <div className='shipment-options__option'>
                <p className='shipment-options__option-intro'>If there is a product missing from this shipment, you can add it.</p>
                <Button
                  component={Link}
                  to={addProductsLink}
                  colorVariant='brand'
                  fill='outline'
                  icon={<PlusCircle />}
                >
                  Add products
                </Button>
              </div>
            )}

            {deleteShipmentLink && <div className='shipment-options__option'>
              <p className='shipment-options__option-intro'>If this shipment was created mistakenly, you can remove it.</p>
              <Button
                colorVariant='danger'
                fill='outline'
                icon={<MinusCircle />}
                onClick={() => {
                  onHandleDeleteAction(deleteShipmentLink)
                }}
              >
                Delete shipment
              </Button>
            </div>}

            <footer className='shipment-options__close'>
              <Button
                component={Link}
                to={redirectLink || closeUrl}
                colorVariant='neutral'
                fill='outline'
                icon={<CloseCircle />}
              >
                Close
              </Button>
            </footer>
          </div>
        </div>
      </Page.Panel>
    </Page>
  )
}

export default ShipmentOptions
